import React from 'react';
import PropTypes from 'prop-types';
import { Card } from '@thd-olt-component-react/card';
import { EtchWidgets } from '@thd-olt-component-react/etch-widgets';
import {
  params,
  shape as shapeType,
  string as stringType,
  useDataModel
} from '@thd-nucleus/data-sources';
import { RevJet } from '../RevJet/RevJet';

export const KeyFeatures = ({ itemId, revJet }) => {

  const { data, loading, error } = useDataModel('product', { variables: { itemId } });

  if (!data || loading || error || !itemId) {
    return null;
  }

  const {
    richContent
  } = data?.product?.media || {};

  if (!richContent && !revJet) {
    return null;
  }

  const etchContent = richContent?.content;
  if (!etchContent && revJet) {
    const thdGlobalDefined = typeof window !== 'undefined'
    && typeof window.THD_GLOBAL !== 'undefined'
    && window.THD_GLOBAL;
    const env = thdGlobalDefined ? 'prod' : 'qa';
    return (
      <Card>
        <RevJet itemId={itemId} envSpace={env} parentId="revJet-key-features-summary" />
        <Card.Content title="Key Features" className="key-features-content">
          <RevJet itemId={itemId} envSpace={env} parentId="revJet-key-features-summary" />
          <Card.Content.Overlay>
            <RevJet itemId={itemId} envSpace={env} parentId="revJet-key-features-overlay" />
          </Card.Content.Overlay>
        </Card.Content>
      </Card>
    );
  }

  return (
    <Card>
      <EtchWidgets content={etchContent} />
      <Card.Content title="Key Features" className="key-features-content">
        <EtchWidgets content={etchContent} />
        <Card.Content.Overlay>
          <EtchWidgets content={etchContent} />
        </Card.Content.Overlay>
      </Card.Content>
    </Card>
  );
};

KeyFeatures.displayName = 'KeyFeatures';

KeyFeatures.dataModel = {
  product: params({ itemId: stringType().isRequired() }).shape({
    dataSources: stringType(),
    itemId: stringType(),
    media: shapeType({
      richContent: shapeType({
        content: stringType()
      })
    })
  })
};

KeyFeatures.propTypes = {
  itemId: PropTypes.string.isRequired,
  revJet: PropTypes.bool,
};

KeyFeatures.defaultProps = {
  revJet: false,
};
